import { Form, Input } from 'antd';
import { CityAsyncSelect } from '@/components/pos/CityAsyncSelect';
import { WardAsyncSelect } from '@/components/pos/WardAsyncSelect';
import { CareStaffAsyncSelect } from '@/components/pos/CareStaffAsyncSelect';
import { DeliveryDaysSelect } from './DeliveryDaysSelect';
import { FloatingField } from './FloatingField';
import { DateMaskInput } from './DateMaskInput';
import {
  citizenIdRules,
  customerBirthdayRules,
  customerEmailRules,
  customerPhoneRules,
  deliveryDaysRules,
  requiredRule,
} from './customerFormSchema';
import type { FulfillmentMode } from '@/pages/POS/types';

interface Props {
  form: import('antd').FormInstance;
  fulfillmentMode: FulfillmentMode;
  storeId?: string;
  cityId?: string;
}

export function DeliverySection({ form, fulfillmentMode, storeId, cityId }: Props) {
  return (
    <>
      {/* Pattern A — FloatingField for typed inputs */}
      <FloatingField
        label="Số điện thoại"
        name="customer_phone"
        rules={customerPhoneRules}
        required
      >
        <Input maxLength={11} />
      </FloatingField>

      <FloatingField label="Họ tên" name="customer_name" rules={[requiredRule('họ tên')]} required>
        <Input />
      </FloatingField>

      <FloatingField label="CCCD" name="citizen_id" rules={citizenIdRules} required>
        <Input maxLength={12} />
      </FloatingField>

      <FloatingField
        label="Thành phố"
        name="customer_city_id"
        rules={[requiredRule('tỉnh/thành phố')]}
        required
      >
        <CityAsyncSelect
          placeholder="Chọn thành phố"
          onChange={(v) => {
            form.setFieldValue('customer_city_id', v);
            // Reset ward when city changes
            form.setFieldsValue({ customer_ward_id: undefined });
          }}
          onChangeWithLabel={(_, name) => form.setFieldValue('_cityName', name)}
        />
      </FloatingField>

      <FloatingField label="Quận / Huyện" name="customer_ward_id">
        <WardAsyncSelect
          cityId={cityId ?? ''}
          placeholder="Chọn phường / xã"
          onChange={(v) => form.setFieldValue('customer_ward_id', v)}
          onChangeWithLabel={(_, name) => form.setFieldValue('_wardName', name)}
        />
      </FloatingField>

      {/* Pattern A continued */}
      <FloatingField label="Địa chỉ" name="customer_address">
        <Input.TextArea autoSize={{ minRows: 1, maxRows: 6 }} />
      </FloatingField>

      <FloatingField label="Email" name="customer_email" rules={customerEmailRules}>
        <Input />
      </FloatingField>

      <FloatingField label="Ngày sinh" name="customer_birthday" rules={customerBirthdayRules}>
        <DateMaskInput />
      </FloatingField>

      <FloatingField label="Ghi chú" name="description">
        <Input.TextArea autoSize={{ minRows: 1, maxRows: 6 }} />
      </FloatingField>

      {/* Care Staff (required) — floating-label giống trường Thành phố */}
      <FloatingField
        label="Nhân viên chăm sóc"
        name="care_staff_id"
        rules={[requiredRule('nhân viên chăm sóc')]}
        required
      >
        <CareStaffAsyncSelect
          placeholder="Chọn nhân viên chăm sóc"
          onChange={(v) => form.setFieldValue('care_staff_id', v)}
          storeId={storeId}
        />
      </FloatingField>

      {/* Pattern B — Delivery Days, only when PREORDER */}
      {fulfillmentMode === 'PREORDER' && (
        <Form.Item
          label="Hạn giao hàng"
          name="delivery_days"
          rules={deliveryDaysRules}
          className="compact-form-item"
        >
          <DeliveryDaysSelect />
        </Form.Item>
      )}
    </>
  );
}
